import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useAssets } from "../assets/AssetsContext";
import { useLocation } from "react-router-dom";

function Contact() {
  const assets = useAssets();
  const location = useLocation();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
    AOS.refresh();
  }, []);

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.replace("#", ""));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" }); // or behavior: "auto"
      }
    }
  }, [location]);
  return (
    <div>
      <div className="innerbanner-section-1">
        <div className="relative-1">
          <div className="s1-heading-text-new ">
            <h1 data-aos="zoom-in">Let’s accelerate what matters—together.</h1>
            <p data-aos="zoom-in">
              At Accel1, we believe in partnerships that drive real-world
              impact. Whether you're a government stakeholder, industry leader,
              investor, researcher, or climate innovator—we’re excited to hear
              from you.
            </p>
            <p data-aos="zoom-in">We don’t just lead companies.</p>
            <p data-aos="zoom-in">
              Let’s collaborate to build the systems that shape a regenerative,
              resilient future.
            </p>
          </div>
          <img
            src={assets.leadershipbanner}
            alt=""
            data-aos="fade-in"
            className="d-d"
          />
          <img
            src={assets.contactbanner2}
            alt=""
            data-aos="fade-in"
            className="m-d"
          />
        </div>
      </div>
      <div className="contact-bg-2 ">
        <div className="wrapper">
          <h2>Reach Out</h2>
          {/* Start */}
          <div className="contact-wrap">
            <div className="contact-1">
              <h3>Global HQ</h3>
              <h6>Accel1 Inc.</h6>
              <p>11720 Amber Park Dr, Ste 160 Alpharetta, GA 30009</p>
              <p>sales@accel1.com</p>
              <p>(678) 568-1858</p>
              <div className="line-2"></div>
              <h3>Other Office Locations</h3>
              <p>
                1-44/1, 2nd Floor, No.201 and 202, Shree Shyam Building,
                <br />
                Hitech City Road, Madhapur, Hyderabad 500081
              </p>
            </div>
            <div className="contact-2">
              {/* <h3>Other Offices</h3> */}
              <h6>Book a Meeting</h6>
              <h6>General Inquiries</h6>
              <p>hello@accel1.com</p>
              <h6>Partnerships & Government Engagement</h6>
              <p>engage@accel1.com</p>
              <h6>Investors & Strategic Collaborations</h6>
              <p>invest@accel1.com</p>
              <h6>Media & Speaking Opportunities</h6>
              <p>press@accel1.com</p>
              <h6>Platform Support & Services</h6>
              <p>support@accel1.com</p>

              <div className="line-2"></div>
              <h6>Follow Us</h6>
              <p>
                Stay in the loop with our latest launches, climate insights, and
                innovation updates:
              </p>
              <div className="soicialmedia-1">
                <a
                  href="https://www.facebook.com/Accel1Horizons/"
                  target="_blank"
                >
                  <img src={assets.fb} alt="" />
                </a>
                <a
                  href="https://www.instagram.com/Accel1Horizons/"
                  target="_blank"
                >
                  <img src={assets.insta} alt="" />
                </a>
                <a
                  href="https://www.linkedin.com/company/accel1/"
                  target="_blank"
                >
                  <img src={assets.linkedin} alt="" />
                </a>
                <a href="https://x.com/accel1horizons" target="_blank">
                  <img src={assets.x} alt="" />
                </a>
              </div>
            </div>
          </div>

          {/* End */}
        </div>
      </div>

      <div className="contact-bg-3" id="Book-Meeting">
        <div className="wrapper">
          <h2>Book a Meeting</h2>
          <p>Want to speak directly with our team?</p>
          <div className="contact-form-wrap">
            <div className="contact-form-1">
              <input type="text" placeholder="Name" className="text-field-1" />
            </div>
            <div className="contact-form-1">
              <input
                type="text"
                placeholder="Company Name"
                className="text-field-1"
              />
            </div>
            <div className="contact-form-1">
              <input type="text" placeholder="Phone" className="text-field-1" />
            </div>
            <div className="contact-form-1">
              <input type="text" placeholder="Email" className="text-field-1" />
            </div>
            <div className="contact-form-1 w-100">
              <textarea
                placeholder="Message"
                className="text-area-1"
              ></textarea>
            </div>
            <div className="contact-form-1 w-100 text-left">
              <button className="button-1">Submit</button>
            </div>
          </div>
        </div>
      </div>
      <div className="contact-bg-4">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2>Let’s Co-Create</h2>
            <p>We work with:</p>
          </div>
          <img src={assets.aproch} alt="VisionImpactImg" />
        </div>
      </div>
      <br />
      <br />
      <div className="wrapper">
        <div className="flagship-heading">
          <h2 className="green-color">
            Together, we can turn climate action into climate advantage.
          </h2>
          <p>We look forward to hearing from you. </p>
        </div>
      </div>
    </div>
  );
}

export default Contact;
